import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=cc060c48&scoped=true&"
import script from "./cgu.js?vue&type=script&lang=js&"
export * from "./cgu.js?vue&type=script&lang=js&"
import style0 from "./cgu.css?vue&type=style&index=0&id=cc060c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc060c48",
  null
  
)

export default component.exports